import axios from 'axios';

import type { AsyncTaskResponse } from '../types/common';
import type {
  FreightBookShipmentRequest,
  FreightCancelShipmentRequest,
  FreightQuoteRequest,
  FreightSaveQuoteRequest,
  FreightShipmentGridRequest,
  FreightTrackShipmentRequest,
} from '../types/freight-requests';
import type {
  FreightCancelShipmentResponse,
  FreightShipment,
  FreightShipmentGridResponse,
  FreightTrackShipmentResponse,
} from '../types/freight-responses';

export const getQuotes = (payload: FreightQuoteRequest): Promise<AsyncTaskResponse> => {
  return axios.post('/freight/quote', payload).then((r) => r.data);
};

export const bookShipment = (payload: FreightBookShipmentRequest): Promise<AsyncTaskResponse> => {
  return axios.post('/freight/book', payload).then((r) => r.data);
};

export const trackShipment = (payload: FreightTrackShipmentRequest): Promise<FreightTrackShipmentResponse> => {
  return axios.post('/freight/track', payload).then((r) => r.data);
};

export const cancelShipment = (payload: FreightCancelShipmentRequest): Promise<FreightCancelShipmentResponse> => {
  return axios.post('/freight/cancel', payload).then((r) => r.data);
};

export const saveQuote = (payload: FreightSaveQuoteRequest): Promise<FreightShipment | null> => {
  return axios.post('/freight/save-quote', payload).then((r) => r.data);
};

export const getSavedQuote = (freightShipmentId: string): Promise<FreightShipment> => {
  return axios.get(`/freight/quote/${freightShipmentId}`).then((r) => r.data);
};

export const getBookedShipment = (freightShipmentId: string): Promise<FreightShipment> => {
  return axios.get(`/freight/shipment/${freightShipmentId}`).then((r) => r.data);
};

export const getShipmentGrid = (payload: FreightShipmentGridRequest): Promise<FreightShipmentGridResponse> => {
  return axios.post('/freight/freightShipmentGrid', payload).then((r) => r.data);
};
